export const buildURLforPatients = ({
  page,
  pageSize,
  firstName,
  lastName,
  phoneNumber,
  accountName,
  accountNumber,
  orderId,
  accountIds,
  dateOfService,
  dateOfBirth,
  searchType,
  search,
}: {
  page?: number;
  pageSize?: number;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  accountName?: string;
  accountNumber?: string;
  orderId?: string;
  accountIds?: string[] | [];
  dateOfService?: string;
  dateOfBirth?: string;
  searchType?: "exact" | "partial";
  search?: string;
}) => {
  const baseUrl = `/patient/all`;
  const pagination =
    page !== undefined && pageSize !== undefined
      ? `page=${page}&pageSize=${pageSize}`
      : null;
  const filtrationParams = [
    !firstName || !firstName.length ? null : `firstName=${firstName}`,
    !lastName || !lastName.length ? null : `lastName=${lastName}`,
    !phoneNumber || !phoneNumber.length ? null : `phoneNumber=${phoneNumber}`,
    !accountName || !accountName.length ? null : `accountName=${accountName}`,
    !accountNumber || !accountNumber.length
      ? null
      : `accountNumber=${accountNumber}`,
    !orderId || !orderId.length ? null : `orderId=${orderId}`,
    !accountIds ? null : `accountIds=${accountIds.join(",")}`,
    !dateOfService || !dateOfService.length
      ? null
      : `dateOfService=${dateOfService}`,
    !dateOfBirth || !dateOfBirth.length ? null : `dateOfBirth=${dateOfBirth}`,
    !searchType ? null : `searchType=${searchType}`,
    // CLE-2708 — the one search box. Encoded, unlike the field filters above: it takes whatever the
    // user typed, so an "&" or a "#" in the term would otherwise cut the query string in half.
    !search || !search.length ? null : `search=${encodeURIComponent(search)}`,
  ];
  const queryParams = [pagination, ...filtrationParams]
    .filter(Boolean)
    .join("&");
  const finalUrl = `${baseUrl}${queryParams ? `?${queryParams}` : ""}`;
  return finalUrl;
};
